import Twig from 'twig';

let Gallery = {
    initFancybox: function(gallery) {
        var item = gallery.find('[data-fancybox]');

        item.fancybox({
            loop : false,
            margin : 0,
            arrows : true,
            infobar : true,
            toolbar : true,
            baseClass: 'fancybox-gallery',
            transitionEffect : "slide",
            animationEffect: "fade",
            animationDuration: 0,
            hash : null,
            buttons : [
                'close'
            ],
            btnTpl : {
                close : '<div data-fancybox-close="true" class="custom-fancybox-close custom-fancybox-close_mobile"></div>',
                smallBtn : '<div data-fancybox-close="true" class="custom-fancybox-close custom-fancybox-close_desktop"></div>',
                arrowLeft: '<button data-fancybox-prev="true" data-btn-infobar-fancybox="true" class="btn-arrow btn-arrow_left ">'+
                                '<span class="svg-icon ">'+
                                    '<svg>'+
                                        '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use>'+
                                    '</svg>'+
                                '</span>'+
                            '</button>',
                arrowRight: '<button  data-fancybox-next="true" data-btn-infobar-fancybox="true" class="btn-arrow">'+
                                '<span class="svg-icon ">'+
                                    '<svg>'+
                                        '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use>'+
                                    '</svg>'+
                                '</span>'+
                            '</button>'
            },
            beforeShow: function (instance, slide) {
                if(gallery.data('fancybox-gallery') == 'video') {
                    $('.fancybox-gallery').find('[data-src-video-fancybox]').html('');
                }
            },
            afterShow: function (instance, slide) {
                let currSlide = $(slide.$slide);

                gallery.find('[data-fancybox-prev]').removeClass('disabled');
                gallery.find('[data-fancybox-next]').removeClass('disabled');

                if(slide.index == 0) {
                    currSlide.find('[data-fancybox-prev]').addClass('disabled');
                }

                if(slide.index == item.length - 1) {
                    currSlide.find('[data-fancybox-next]').addClass('disabled');
                }

                if(gallery.data('fancybox-gallery') == 'video') {

                    let videoContainer = $('.fancybox-gallery').find('[data-src-video-fancybox]'),
                        currSrcVideo = currSlide.find('[data-src-video-fancybox]').data('src-video-fancybox');

                    videoContainer.html('<iframe src="' + currSrcVideo + '" frameborder="0" allowfullscreen=""></iframe>');
                }

                Gallery.setPositionArrowFancyboxGallery(slide);
            },
            afterLoad: function(instance, current) {
                gallery.find('[data-inner-content-fancybox-gallery-detail]').on('load', function(){
                    Gallery.setPositionArrowFancyboxGallery($.fancybox.getInstance().current);
                });
            }
        });
    },
    setPositionArrowFancyboxGallery: function(slide) {
        var $window = $(window),
            arr = $('[data-btn-infobar-fancybox]'),
            currSlide = $(slide.$slide),
            $wrapContentGallery = currSlide.find('[data-wrap-content-fancybox-gallery-detail]'),
            $contentGallery = $wrapContentGallery.find('[data-content-fancybox-gallery-detail]'),
            $innerContentGallery = $contentGallery.find('[data-inner-content-fancybox-gallery-detail]');

        arr.css({
            // 16 - отступ стрелок сверху от контента галереи
            'top': ($window.outerHeight() - $wrapContentGallery.outerHeight())/2 + $contentGallery.position().top + $innerContentGallery.outerHeight() + 16 + 'px'
        });

        arr.each(function(index) {
            var $this = $(this),
                rightArr = 0;

            if($this.data('fancybox-prev')) {
                // 8 - отступ между стрелками
                rightArr = $this.outerWidth() + 8;
            }

            $this.css({
                // Получаем половину ширины пустой области экрана
                'right': ($window.outerWidth() - $innerContentGallery.outerWidth())/2 + rightArr + 'px' 
            });
        });
    },
    addAjax: function(btnMore) {
        let typeBtn = btnMore.data('btn-type-show-more-gallery'),
            currPage = btnMore.data('btn-page-show-more-gallery'),
            pageSize = btnMore.data('btn-size-show-more-gallery'),
            galleryId,
            reportId;
        let inData = {
          size: pageSize,
          PAGEN_1: currPage + 1
        };

        if (galleryId = btnMore.closest('.tabs__pane').attr('data-gallery-id')) {
            inData.gallery = galleryId;
        }
        if (reportId = btnMore.closest('.tabs__pane').attr('data-report-id')) {
            inData.report = reportId;
        }
            
        $.ajax({
            url: '/'+window.langId+'/ajax/gallery-' + typeBtn + '.php',
            data: inData,
            dataType: 'json',
            beforeSend: function(){},
            success: function(_data){

                btnMore.data('btn-page-show-more-gallery', currPage + 1);
                
                if(currPage + 1 >= _data.nav_info.page_count) {
                    btnMore.hide();
                }

                if(_data.items.length > 0){

                    let gallery = $('[data-fancybox-gallery="' + typeBtn + '"]'),
                        container = $('[data-container-show-more-gallery="' + typeBtn + '"]'),
                        countItemList = container.find('[data-fancybox]').length;

                    container.find('[data-fancybox-next]').removeClass('disabled');

                    switch(typeBtn) {
                        case 'photo':
                            Gallery.addPhoto(_data.items, container, countItemList);
                            break;

                        case 'video':
                            Gallery.addVideo(_data.items, container, countItemList);
                            break;

                      default:
                        break;
                    }

                    // pagination
                    if (_data.nav_info.page_count <= 1) {
                        $('.gallery__pagination').hide();
                    } else {
                        var paginationTemplate = Twig.twig({
                            data: '<div class="pagination" data-current-page="{{data.currentPage}}">\n' +
                            '    {% if data.currentPage == 1 %}\n' +
                            '        <div class="pagination__prev disabled">\n' +
                            '            <span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use></svg></span>\n' +
                            '        </div>\n' +
                            '    {% else %}\n' +
                            '        <a href="{{ data.listUrl }}?PAGEN_1={{  data.currentPage - 1 }}" class="pagination__prev">\n' +
                            '            <span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use></svg></span>\n' +
                            '        </a>\n' +
                            '    {% endif %}\n' +
                            '    <div class="pagination__content">\n' +
                            '        <span class="pagination__current-page">{{data.currentPage}}</span>\n' +
                            '        <span class="">{% if data.strOf is empty %} из {% else %} {{ data.strOf }} {% endif %} {{data.countAllPage}}</span>\n' +
                            '    </div>\n' +
                            '    {% if data.currentPage == data.countAllPage or data.countAllPage == 0 %}\n' +
                            '        <div class="pagination__next disabled">\n' +
                            '            <span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use></svg></span>\n' +
                            '        </div>\n' +
                            '    {% else %}\n' +
                            '        <a href="{{ data.listUrl }}?PAGEN_1={{ data.currentPage + 1 }}" class="pagination__next">\n' +
                            '            <span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use></svg></span>\n' +
                            '        </a>\n' +
                            '    {% endif %}\n' +
                            '</div>'
                          }
                        );

                        var $pagination = $('.gallery__pagination');
                        $pagination.show();
                        $pagination.html(
                          paginationTemplate.render({
                            data: {currentPage: _data.nav_info.cur_page, countAllPage: _data.nav_info.page_count, navNum: $pagination.attr('data-nav-num')}
                          })
                        );
                    }

                    Gallery.initFancybox(gallery);
                }
            }
        });
    },
    addPhoto: function(listData, listContainer, countItemList){
        var template = Twig.twig({
            data:   '<div class="item-gallery">'+
                        '<a href="javascript:;" data-src="#gallery-photo{{ data.id }}" data-fancybox="group" class="item-gallery__link">'+
                            '<div class="item-gallery__preview-img" style="background-image: url(\'{{ data.img }}\')"></div>'+
                            '<div class="item-gallery__preview-title">{{ data.title|raw }}</div>'+
                        '</a>'+
                        '<div id="gallery-photo{{ data.id }}" class="item-gallery__content-wrap" data-wrap-content-fancybox-gallery-detail="true">'+
                            '<div  class="item-gallery__content" data-content-fancybox-gallery-detail="true">'+
                                '<div class="item-gallery__inner-content">'+
                                    '<img src="{{ data.img }}" data-inner-content-fancybox-gallery-detail="true">'+
                                    '<a data-fancybox-prev="true" class="img-prev" href="javascript:;"></a>'+
                                    '<a data-fancybox-next="true" class="img-next" href="javascript:;"></a>'+
                                '</div>'+
                                '<div class="item-gallery__title">{{ data.title|raw }}</div>'+
                            '</div>'+
                        '</div>'+
                    '</div>'
        });

        listData.forEach(function(item, i){
            listContainer.append(template.render({
                data: {
                    id: item.ID,
                    img: item.DETAIL_PICTURE,
                    title: item.title
                }
            }));
        });
    },
    addVideo: function(listData, listContainer, countItemList){
        var lang = $('html').attr('lang'),
            titleTime = (lang === 'en') ? 'Duration': 'Продолжительность';

        var template = Twig.twig({
            data:   '<div class="item-gallery">'+
                        '<a href="javascript:;" data-src="#gallery-video{{ data.id }}" data-fancybox="group" class="item-gallery__link">'+
                            '<div class="item-gallery__preview-img" style="background-image: url(\'http://img.youtube.com/vi/{{ data.src }}/maxresdefault.jpg\')"></div>'+
                            '<div class="item-gallery__preview-title">{{ data.title|raw }}</div>'+
                        '</a>'+
                        '<div id="gallery-video{{ data.id }}" class="item-gallery__content-wrap" data-wrap-content-fancybox-gallery-detail="true">'+
                            '<div  class="item-gallery__content" data-content-fancybox-gallery-detail="true">'+
                                '<div class="item-gallery__inner-content item-gallery__inner-content_video">'+
                                    '<div class="youtube-video" data-src-video-fancybox="https://www.youtube.com/embed/{{ data.src }}" data-inner-content-fancybox-gallery-detail="true" data-src-video-gallery="{{ item.src }}"></div>'+
                                    '<a data-fancybox-prev="true" class="img-prev" href="javascript:;"></a>'+
                                    '<a data-fancybox-next="true" class="img-next" href="javascript:;"></a>'+
                                '</div>'+
                                '<div class="item-gallery__time"><b>' + titleTime + '</b> <span data-time-video-gallery="true">{{ data.time }}</span></div>'+
                                '<div class="item-gallery__title">{{ data.title|raw }}</div>'+
                            '</div>'+
                        '</div>'+
                    '</div>'
        });

        listData.forEach(function(item, i){
            Gallery.setTimeVideo(item.src, function(_time){
                listContainer.append(template.render({
                    data: {
                        id: item.ID,
                        src: item.src,
                        title: item.title,
                        time: _time
                    }
                }));
            });
        });
    },
    setTimeVideo: function(srcVideo, callback){
        var youtubeUrl = 'https://www.googleapis.com/youtube/v3/videos?id=' + srcVideo + '&part=contentDetails&key=AIzaSyCI46kdRhRihTFSLnA_gYI5GrSGOkOBPaY';

        $.ajax({
            async: false,
            type: 'GET',
            url: youtubeUrl,
            success: function(data) {
                var youtube_time = data.items[0].contentDetails.duration,
                    time = Gallery.parseDurationVideo(youtube_time);

                if (callback != undefined) callback(time);
            }
        });
    },
    parseDurationVideo: function(duration){
        var matches = duration.match(/[0-9]+[HMS]/g);

        var time = {
            seconds: 0,
            minutes: 0,
            hours: 0
        }

        matches.forEach(function (part) {
            var unit = part.charAt(part.length-1);
            var amount = parseInt(part.slice(0,-1));

            switch (unit) {
                case 'H':
                    time.hours += amount;
                    break;
                case 'M':
                    time.minutes += amount;
                    break;
                case 'S':
                    time.seconds += amount;
                    break;
                default:
                    break;
            }
        });

        time.seconds = (time.seconds == 0) ? 59 : (time.seconds - 1);
        time.minutes = (time.seconds != 59) ?
                                time.minutes:
                                (time.minutes == 0) ? 59 : (time.minutes - 1);

        time.seconds = (time.seconds >= 10) ? time.seconds : '0'+time.seconds;

        if(time.minutes == 0) {
            time.minutes = (time.hours > 0) ? '00:' : time.minutes+':';
        }else{
            time.minutes = ((time.hours > 0) && !(time.minutes >= 10)) ? '0'+time.minutes+':' : time.minutes+':';
        }

        time.hours = (time.hours > 0) ? time.hours + ':' : '';

        return time.hours + time.minutes + time.seconds;
    }
}

$(document).ready(function($) {
    let listVideo = $('[data-src-video-gallery]');
    if(listVideo.length) {
        listVideo.each(function() {
            var $this = $(this);
            Gallery.setTimeVideo($this.data('src-video-gallery'), function(time){
                $this.closest('[data-content-fancybox-gallery-detail]').find('[data-time-video-gallery]').text(time);
            });
        });
    }

    let fancyboxGallery = $('[data-fancybox-gallery]');
    if(fancyboxGallery.length) {

        fancyboxGallery.each(function() {
            Gallery.initFancybox($(this));

            $(window).resize(function(){
                if($.fancybox.getInstance().current) {
                    Gallery.setPositionArrowFancyboxGallery($.fancybox.getInstance().current);
                }
            });
        });
    }

    let btnShowMore = $('[data-btn-type-show-more-gallery]');
    if(btnShowMore.length) {

        btnShowMore.on('click', function(e){
            e.preventDefault();

            Gallery.addAjax($(this));
        });
    }

    $('.gallery .tabs__nav-item').on('click', function() {
        $.cookie('gallery_tab', $(this).data('item-nav-tabs'));
    });
    
    $('.report-detail .tabs__nav-item').on('click', function() {
        $.cookie('report_tab', $(this).data('item-nav-tabs'));
    });
});


// WEBPACK FOOTER //
// ./components/gallery.js